import { useEffect, useState } from 'react';
import { listBoards, type BoardSummary } from '../sync/boardsApi';
import { IconClose } from '../ui/icons';
import { BoardPage } from './BoardPage';
import { navigate, paths } from './router';

/** One board, or two side by side (split view). Each half is a full BoardPage with its own camera. */
export function Workspace({ primary, split, view }: { primary: string; split: string | null; view: string | null }) {
  if (!split) return <BoardPage key={primary} boardId={primary} remote view={view} />;
  return (
    <div className="workspace split">
      <div className="split-pane">
        <BoardPage key={primary} boardId={primary} remote view={view} />
      </div>
      <div className="split-pane">
        <SplitHeader primary={primary} current={split} />
        <div className="split-body">
          <BoardPage key={split} boardId={split} remote view={null} />
        </div>
      </div>
    </div>
  );
}

function SplitHeader({ primary, current }: { primary: string; current: string }) {
  const [boards, setBoards] = useState<BoardSummary[]>([]);
  useEffect(() => {
    listBoards().then(setBoards).catch(() => setBoards([]));
  }, []);
  return (
    <div className="split-header" onPointerDown={(e) => e.stopPropagation()}>
      <select className="font-select" value={current} onChange={(e) => navigate(paths.board(primary, e.target.value))} title="Board in this pane">
        {!boards.some((b) => b.id === current) && <option value={current}>{current === primary ? 'Same board' : current}</option>}
        {boards.map((b) => (
          <option key={b.id} value={b.id}>
            {b.title}
            {b.id === primary ? ' (same board)' : ''}
          </option>
        ))}
      </select>
      <button type="button" className="panel-close" title="Close split view" aria-label="Close split view" onClick={() => navigate(paths.board(primary))}>
        <IconClose />
      </button>
    </div>
  );
}
